import { Car } from 'lucide-react';
import React from 'react';

import { SingleSheetImportPage } from '@/features/imports/SingleSheetImportPage';

export const ImportTransfersPage = (): React.JSX.Element => (
  <SingleSheetImportPage
    config={{
      moduleKey: 'transfer',
      titleSingular: 'transfer',
      titlePlural: 'transfers',
      routePrefix: 'transfers',
      listPath: '/transfers',
      ListIcon: Car,
      invalidateOnSuccess: ['transfers'],
      summaryFields: ['name', 'city', 'transferType'],
    }}
  />
);
